var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"app-header-title"},[_vm._v("\n  лента: "),_c('span',{staticClass:"feed-title"},[_vm._v(_vm._s(_vm.threadName))])])}
var staticRenderFns = []

export { render, staticRenderFns }